module.exports = __webpack_public_path__ + "img/recursos-avancados.9481ce2d.png";